import React from 'react';
import { Button } from '../../components/Button';
/**
 * Bottom "Back" button — goes to previous history entry.
 */
export function BackButton() {
  return <Button variant="primary" className="bg-red-700 hover:bg-red-800 focus:ring-red-700 px-8" onClick={() => window.history.back()} data-id="element-346">
      Back
    </Button>;
}